

export interface Order {
    data: {
        orderId: string
    }
};

export const initialState: Order = {
    data: {
        orderId: ''
    }
};




export type OrderState = Readonly<Order>;